import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import { Field } from "formik";
import { fieldToSelect, Select } from "app/components/FormikField/base";
import { DatePicker } from "app/components/FormikField";
import { FormattedMessage } from "react-intl";
import { Button, InputLabel, MenuItem, Select as MuiSelect } from "@mui/material";
import { useSelector } from "react-redux";
const ConnectionRunForm = () => {
  const { selectedRow } = useSelector((state) => state.ConnectionsReducer);
  const tenants = selectedRow?.packages[0].settings.tenants;
  let tagsControl = "";
  function CustomSelect(props) {
    const {
      form: { setFieldValue },
      field: { name }
    } = props;
    const onChange = React.useCallback(
      (event) => {
        const { value } = event.target;
        if (value.indexOf("controls") !== -1) {
          tagsControl && tagsControl === "all" ? setFieldValue(name, tenants) : setFieldValue(name, []);
        } else {
          tagsControl = "";
          setFieldValue(name, value);
        }
      },
      [setFieldValue, name]
    );
    return /* @__PURE__ */ React.createElement(MuiSelect, { ...fieldToSelect(props), onChange });
  }
  const datePicker = useMemo(() => {
    return {
      type: "date",
      name: "date",
      label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.date" }),
      required: true
    };
  }, []);
  return /* @__PURE__ */ React.createElement(Grid, { container: true }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(DatePicker, { field: datePicker })), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(InputLabel, { shrink: true, htmlFor: "tenants" }, "Tenants:"), /* @__PURE__ */ React.createElement(
    Field,
    {
      required: true,
      color: "secondary",
      component: CustomSelect,
      name: "tenants",
      multiple: true,
      value: tenants,
      label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.tenants" }),
      fullWidth: true
    },
    /* @__PURE__ */ React.createElement(MenuItem, { value: "controls" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        onClick: () => {
          tagsControl = "all";
        }
      },
      "All"
    ), /* @__PURE__ */ React.createElement(
      Button,
      {
        onClick: () => {
          tagsControl = "reset";
        }
      },
      "Reset"
    )),
    tenants.sort((a, b) => a.code.localeCompare(b.code)).map((option) => /* @__PURE__ */ React.createElement(MenuItem, { key: option.id, value: option }, option.code))
  )), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(InputLabel, { shrink: true, htmlFor: "extractionType" }, "Select Extraction:"), /* @__PURE__ */ React.createElement(
    Field,
    {
      required: true,
      color: "secondary",
      component: Select,
      name: "extractionType",
      label: /* @__PURE__ */ React.createElement(FormattedMessage, { id: "connections.extractionType" }),
      fullWidth: true
    },
    /* @__PURE__ */ React.createElement(MenuItem, { value: "xeinadin_group_start_reports_extraction" }, "Trial Balances"),
    /* @__PURE__ */ React.createElement(MenuItem, { value: "xeinadin_group_start_invoices_extraction" }, "Invoices"),
    /* @__PURE__ */ React.createElement(MenuItem, { value: "xeinadin_group_start_contacts_extraction" }, "Contacts")
  )));
};
export default ConnectionRunForm;
